import { addToCart, renderCartDrawer, CartError } from './b-cart-api.js';

class QuickAddBar extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  onClick = async (event) => {
    const toggle = event.target.closest('[data-quick-toggle]');
    if (toggle) {
      const open = !this.classList.contains('is-open');
      this.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      return;
    }
    const button = event.target.closest('[data-variant-id]');
    if (!button || button.disabled) return;

    const error = document.getElementById(this.dataset.errorId);
    if (error) error.hidden = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      const data = await addToCart([{ id: Number(button.dataset.variantId), quantity: 1 }]);
      this.classList.remove('is-open');
      button.classList.add('is-added');
      setTimeout(() => button.classList.remove('is-added'), 1200);
      renderCartDrawer(data);
    } catch (err) {
      if (error) {
        error.textContent = err instanceof CartError ? err.message : 'No pudimos agregar el producto. Intenta de nuevo.';
        error.hidden = false;
      }
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  };
}

if (!customElements.get('quick-add-bar')) customElements.define('quick-add-bar', QuickAddBar);
